import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { FileTextIcon, BookOpenIcon, GiftIcon, PenLineIcon, TabletSmartphoneIcon, MailIcon, MonitorSmartphoneIcon, CloudDownloadIcon } from 'lucide-react';
const GOLD = '#d8b878';
const ITEMS = [{
  icon: FileTextIcon,
  title: 'Ebook principal en PDF',
  text: '¿Estás listo para jugar?'
}, {
  icon: BookOpenIcon,
  title: '118 páginas de lectura profunda',
  text: 'Una experiencia simbólica sobre conciencia, patrones, miedo, ego, relaciones y realidad.'
}, {
  icon: GiftIcon,
  title: 'Bono incluido',
  text: 'Cuaderno de Reflexión “Despierta el Juego” — 31 páginas.'
}, {
  icon: PenLineIcon,
  title: 'Workbook de aplicación',
  text: 'Ejercicios guiados, preguntas profundas y espacios de escritura consciente.'
}, {
  icon: TabletSmartphoneIcon,
  title: 'Acceso interactivo protegido',
  text: 'Versiones flipbook del ebook y del bono para leer desde tu navegador.'
}, {
  icon: MailIcon,
  title: 'Entrega inmediata por correo',
  text: 'Recibe tus archivos digitales después de completar la compra.'
}, {
  icon: MonitorSmartphoneIcon,
  title: 'Lectura desde celular, tablet o computadora',
  text: 'Accede a tus materiales desde cualquier dispositivo.'
}, {
  icon: CloudDownloadIcon,
  title: 'Producto 100% digital',
  text: 'Sin envío físico.'
}];
export function WhatYouGet() {
  const container = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.08
      }
    }
  };
  const item = {
    hidden: {
      opacity: 0,
      y: 22
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.5
      }
    }
  };
  return <section className="relative overflow-hidden bg-matrix-black py-20 md:py-28 px-5 md:px-8" data-id="element-405">
      {/* Subtle digital texture + depth */}
      <div className="pointer-events-none absolute inset-0 z-0 opacity-[0.04]" style={{
      backgroundImage: 'repeating-linear-gradient(90deg, rgba(0,255,65,0.6) 0px, rgba(0,255,65,0.6) 1px, transparent 1px, transparent 10px)',
      maskImage: 'radial-gradient(ellipse at center, black 25%, transparent 80%)',
      WebkitMaskImage: 'radial-gradient(ellipse at center, black 25%, transparent 80%)'
    }} data-id="element-406"></div>
      <div className="pointer-events-none absolute inset-0 z-0 bg-[radial-gradient(ellipse_at_top,_rgba(216,184,120,0.06)_0%,_transparent_55%)]" data-id="element-407"></div>
      {/* Ambient depth rising from the bottom + soft transition in */}
      <div className="pointer-events-none absolute inset-x-0 bottom-0 z-0 h-2/3 bg-[radial-gradient(ellipse_at_bottom,_rgba(0,255,65,0.07)_0%,_transparent_60%)]" data-id="element-408"></div>
      <div className="pointer-events-none absolute inset-x-0 top-0 z-0 h-24 bg-gradient-to-b from-matrix-black to-transparent" data-id="element-409"></div>

      <div className="max-w-5xl mx-auto relative z-10" data-id="element-410">
        {/* Header */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-80px'
      }} transition={{
        duration: 0.8
      }} className="text-center mb-12 md:mb-16 max-w-2xl mx-auto" data-id="element-411">
          <span className="inline-block font-inter text-[10px] md:text-xs tracking-[0.4em] uppercase mb-5" style={{
          color: 'rgba(216,184,120,0.7)'
        }} data-id="element-412">
            Tu acceso
          </span>
          <h2 className="font-cinzel text-3xl md:text-4xl lg:text-5xl text-matrix-cream mb-6 drop-shadow-[0_0_12px_rgba(245,230,200,0.12)]" data-id="element-413">
            ¿Qué recibes con tu compra?
          </h2>
          <p className="text-[15px] md:text-lg text-matrix-white/80 font-light leading-[1.9]" data-id="element-414">
            Al completar tu compra, recibirás acceso inmediato a un paquete
            digital completo diseñado para leer, reflexionar y aplicar las ideas
            del ebook a tu propia vida.
          </p>
        </motion.div>

        {/* Benefit cards */}
        <motion.div variants={container} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-50px'
      }} className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5" data-id="element-415">
          {ITEMS.map(({
          icon: Icon,
          title,
          text
        }, i) => <motion.div key={i} variants={item} whileHover={{
          y: -4,
          boxShadow: '0 0 32px -10px rgba(216,184,120,0.38)'
        }} className="group flex flex-col items-start gap-3 sm:gap-4 rounded-xl border border-matrix-green/15 bg-matrix-dark/50 backdrop-blur-sm p-4 sm:p-5 md:p-6 transition-colors duration-300 hover:border-[rgba(216,184,120,0.4)]" data-id="element-416">
              <span className="shrink-0 flex h-9 w-9 sm:h-11 sm:w-11 items-center justify-center rounded-lg border border-[rgba(216,184,120,0.22)] bg-matrix-green/[0.06] transition-colors group-hover:border-[rgba(216,184,120,0.5)]" style={{
            color: GOLD
          }} data-id="element-417">
                <Icon className="w-[18px] h-[18px] sm:w-5 sm:h-5" strokeWidth={1.5} data-id="element-418" />
              </span>
              <div data-id="element-419">
                <h3 className="font-cinzel text-[15px] md:text-base text-matrix-cream leading-snug mb-1.5" data-id="element-420">
                  {title}
                </h3>
                <p className="text-matrix-white/75 text-[13px] md:text-[14px] font-light leading-snug" data-id="element-421">
                  {text}
                </p>
              </div>
            </motion.div>)}
        </motion.div>

        {/* Closing phrase */}
        <motion.p initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} className="text-center mt-12 md:mt-16 max-w-2xl mx-auto font-cinzel text-lg sm:text-xl md:text-2xl leading-[1.5] text-matrix-cream" style={{
        textShadow: '0 0 22px rgba(216,184,120,0.18)'
      }} data-id="element-422">
          Todo en un formato digital{' '}
          <span style={{
          color: GOLD
        }} data-id="element-423">
            simple, directo y fácil de usar
          </span>{' '}
          desde cualquier dispositivo.
        </motion.p>
      </div>
    </section>;
}